import { component } from 'picoapp';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const signUpTitle = node.querySelector('#sign_up_title');
  const klaviyoEmailForm = node.querySelector('#klaviyo_email_form');

  const passwordWrapper = node.closest('[data-password-wrapper]');
  const mainElement = passwordWrapper?.closest('main');
  const passwordContentWrapper = mainElement?.querySelector('[data-password-content-wrapper]');
  const pagePasswordInput = node.querySelector('#page-password-input');
  const pagePasswordButton = node.querySelector('#page-password-button');

  /**
   * Functions
   */

  const onPasswordInput = (input) => {
    if (!pagePasswordInput && !pagePasswordButton) return;

    const password = input.value.trim();
    if (password.length === 0) {
      return;
    }
    try {
      localStorage.setItem('page-passwords', password);
      window.location.reload();
    } catch (error) {
      console.error('Failed to save to localStorage:', error);
    }
  };
  const displayKlaviyoEmailForm = () => {
    if (!signUpTitle && !klaviyoEmailForm) return;

    signUpTitle.addEventListener('click', function () {
      klaviyoEmailForm.classList.toggle('hidden');
      signUpTitle.classList.toggle('hidden');
    });
  };

  const checkPassword = () => {
    let password = localStorage.getItem('page-passwords') || '';
    if (theme.cacheId) {
      if (theme.cacheId === password) {
        passwordContentWrapper?.classList.remove('hidden');
        passwordWrapper?.classList.add('hidden');
      } else {
        passwordWrapper?.classList.remove('hidden');
        passwordContentWrapper?.classList.add('hidden');
      }
      localStorage.setItem('page-passwords', password);
    } else if (passwordWrapper) {
      passwordContentWrapper?.classList.remove('hidden');
      passwordWrapper?.classList.add('hidden');
    }
  };

  const submitPasswordForm = () => {
    if (!pagePasswordInput && !pagePasswordButton) return;

    pagePasswordButton.addEventListener('click', function () {
      onPasswordInput(pagePasswordInput);
    });

    pagePasswordInput.addEventListener('keypress', function (e) {
      if (e.keyCode == 13) {
        onPasswordInput(pagePasswordInput);
      }
    });
  };

  const init = () => {
    checkPassword();
    displayKlaviyoEmailForm();
    submitPasswordForm();
  };

  /**
   * Init
   */
  init();
});
